function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-set": "notify",
  d: "M17.8288 14.0942C16.5689 13.0292 15.8464 11.4725 15.8464 9.8233V7.5C15.8464 4.56757 13.6681 2.14005 10.8464 1.7334V0.833282C10.8464 0.372467 10.473 0 10.013 0C9.55307 0 9.17969 0.372467 9.17969 0.833282V1.7334C6.35712 2.14005 4.17969 4.56757 4.17969 7.5V9.8233C4.17969 11.4725 3.45718 13.0292 2.18964 14.1008C1.86554 14.3784 1.67969 14.7816 1.67969 15.2083C1.67969 16.0126 2.33383 16.6667 3.13797 16.6667H16.888C17.6923 16.6667 18.3464 16.0126 18.3464 15.2083C18.3464 14.7816 18.1606 14.3784 17.8288 14.0942Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-set": "notify",
  d: "M10.0128 20C11.5221 20 12.7846 18.9241 13.0745 17.5H6.95117C7.24124 18.9241 8.50375 20 10.0128 20Z",
  fill: "white"
});

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-set": "notify",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.acb28d0b.svg";
export { ForwardRef as ReactComponent };